import AppNavbar, { AppTab } from "../../../AppNavbar/AppNavbar";
import { useSearchParams } from "react-router-dom";

interface Props {
  tabs: AppTab[];
}

export default function BrieChatWithGCHeader({ tabs }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const commentsActive = searchParams.get("comments");
  const gptActive = searchParams.get("brie");
  let activeTab = commentsActive
    ? "Comments"
    : gptActive
    ? "BrieGPT"
    : "Comments";

  return (
    <div>
      <AppNavbar
        tabs={[{ title: "Comments", activeValue: "Comments" }, ...(tabs || [])]}
        activeTab={activeTab}
        onSelect={(newTab: string) => {
          if (newTab === "Comments") {
            searchParams.set("comments", "true");
            searchParams.delete("brie");
            setSearchParams(searchParams);
          } else if (newTab === "BrieGPT") {
            searchParams.set("brie", "true");
            searchParams.delete("comments");
            setSearchParams(searchParams);
          }
        }}
      />
    </div>
  );
}
